import { useQuery } from 'react-query';

import { taskApi } from 'src/Services/API';

const useFetchMyTasks = () => {
  return useQuery(['my-tasks'], () => taskApi.findMyPendingTasks(), {
    staleTime: 2 * 60 * 1000,
  });
};

export default useFetchMyTasks;
